import React from 'react'

export default function InputCnpjCpf({
  value,
  onChange,
  label,
  labelColor = '#14B0BF',
  width = '100%',
  marginTop = 20,
  disabled = false,
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: labelColor,
      display: 'block',
    },
    input: {
      width,
      outline: 'none',
      border: '1px solid  #F1F1F1',
      borderRadius: 3,
      height: 30,
      marginTop: 3,
      padding: 10,
    },
  }

  const formatCpfCnpj = raw => {
    if (!raw) {
      return { cleaned: '', formatted: '', isCpf: true }
    }

    const alnum = raw.replace(/[^0-9a-zA-Z]/g, '').toUpperCase()
    const digitsOnly = alnum.replace(/\D/g, '')

    // CPF: só números, até 11 dígitos, e a string toda é numérica
    const isCpf = alnum.length === digitsOnly.length && digitsOnly.length <= 11

    if (isCpf) {
      const cleaned = digitsOnly.slice(0, 11)
      let v = cleaned

      if (v.length > 3) v = v.slice(0, 3) + '.' + v.slice(3)
      if (v.length > 7) v = v.slice(0, 7) + '.' + v.slice(7)
      if (v.length > 11) v = v.slice(0, 11) + '-' + v.slice(11)

      return { cleaned, formatted: v, isCpf: true }
    }

    // CNPJ: 12 primeiros = alfanumérico, 2 últimos = dígitos
    const head = alnum.slice(0, 12)
    const tailRaw = alnum.slice(12, 14)
    const tailDigits = tailRaw.replace(/\D/g, '').slice(0, 2)

    const cleaned = (head + tailDigits).slice(0, 14)

    let v = cleaned
    if (v.length > 2) v = v.slice(0, 2) + '.' + v.slice(2)
    if (v.length > 6) v = v.slice(0, 6) + '.' + v.slice(6)
    if (v.length > 10) v = v.slice(0, 10) + '/' + v.slice(10)
    if (v.length > 15) v = v.slice(0, 15) + '-' + v.slice(15)

    return { cleaned, formatted: v, isCpf: false }
  }

  const { formatted } = formatCpfCnpj(value || '')

  const handleChange = e => {
    const inputValue = e.target.value || ''
    const { cleaned, formatted } = formatCpfCnpj(inputValue)

    if (onChange) {
      onChange({ value: cleaned, formattedValue: formatted })
    }
  }

  return (
    <div style={styles.container}>
      <label style={styles.label} htmlFor="myInput">
        {label}
      </label>
      <input style={styles.input} disabled={disabled} value={formatted} onChange={handleChange} />
    </div>
  )
}
